import { Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Workplace } from '../../../../api/app-types/workplace.app';
import { LvrSimplePanel } from '../../../../core/components/simple-panel/simple-panel';
import { User } from '../../../../api/app-types/user.app';
import { RoleId } from '../../../../api/app-types/role.app';
@Component({
	selector: 'lvr-workplace-accordion',
	imports: [TranslocoPipe, LvrSimplePanel],
	templateUrl: './workplace-accordion.html',
	styleUrl: './workplace-accordion.scss',
})
export class WorkplaceAccordion {
	public readonly workplace = input<Workplace | undefined>();
	public readonly institutionName = input<string>('');
	public readonly user = input.required<User>();
	public readonly eaaRole = RoleId.EAA;
}
